import { Icon } from "@iconify/react";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import LoaderComp from "../../LoaderComp";
import { getCallId } from "../../Redux/UserSlice";
import { backendApi } from "../../services/service";

const SorryPageComplete = ({ languageContent }) => {
  const call_id = useSelector(getCallId);
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        console.log(e.message);
      });
  };
  useEffect(() => {
    submitApi("error_page", "open");
  }, []);
  return (
    <>
      {Object.values(languageContent).length > 0 ? (
        <>
          <Icon
            icon="bx:bxs-error-circle"
            color="#c7222a"
            height="3rem"
            width="3rem"
          />
          <p>{languageContent.error_page.sorry}</p>
          <p>{languageContent.flowComplete}</p>
        </>
      ) : (
        <LoaderComp />
      )}
    </>
  );
};

export default SorryPageComplete;
